import { useMediaQuery, useTheme } from '@cmg/design-system';

export function useIsSmallScreen() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
